import { useIsMobile } from '@/hooks/use-mobile'
import { TopDiscountsTodayBaseProps } from './TopDiscountsTodayBase'
import { TopDiscountsTodayMobile } from './TopDiscountsTodayMobile'
import { TopDiscountsTodayDesktop } from './TopDiscountsTodayDesktop'

/**
 * Unified TopDiscountsToday component that renders mobile or desktop version
 * Uses useIsMobile hook to conditionally render the appropriate version
 * This approach separates mobile and desktop code completely
 * 
 * @example
 * ```tsx
 * <TopDiscountsToday
 *   items={discountedAssets}
 *   onItemClick={handleItemClick}
 *   onBuyClick={handleBuyClick}
 *   loading={loading}
 * />
 * ```
 */
export const TopDiscountsToday = (props: TopDiscountsTodayBaseProps) => {
  const isMobile = useIsMobile()

  // Completely separate mobile and desktop rendering
  // No CSS classes mixing - pure conditional rendering
  if (isMobile) {
    return <TopDiscountsTodayMobile {...props} />
  }

  return <TopDiscountsTodayDesktop {...props} />
}

